import type { Nullable } from '../../../models';
import type { SequenceAdV5 } from '../types';
import type { TransientSequenceError } from './state';

export enum SequenceAction {
  SET_SEARCH_UNSEQUENCED_ADS_TERM = 'SET_SEARCH_UNSEQUENCED_ADS_TERM',
  SET_SEQUENCED_ADS_ORDER = 'SET_SEQUENCED_ADS_ORDER',
  SET_TRANSIENT_SEQUENCE_ERROR = 'SET_TRANSIENT_SEQUENCE_ERROR',
}

export type SequenceActions =
  | { type: SequenceAction.SET_SEARCH_UNSEQUENCED_ADS_TERM; payload: string }
  | { type: SequenceAction.SET_SEQUENCED_ADS_ORDER; payload: SequenceAdV5[] }
  | { type: SequenceAction.SET_TRANSIENT_SEQUENCE_ERROR; payload: Nullable<TransientSequenceError> };
